export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15004.4629d0bd.jpg";